<template>
  <div id='app'>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      screenScale: 1, // 屏幕缩放比例
    }
  },
  created() {
    this.getInnerInfo();// 在初始化时获取窗口高度
    window.addEventListener('resize', this.getInnerInfo); // 在窗口大小改变时重新获取窗口高度
  },
  methods: {
    // 获取浏览器宽高
    getInnerInfo() {
      let innerWidth = window.innerWidth;
      let innerHeight = window.innerHeight;
      let rate = innerHeight / innerWidth;
      if (rate < 0.5625) {
        console.log("高/宽<1080/1920");
        this.screenScale = innerHeight / 1080;
      } else if (rate > 0.5625) {
        console.log("高/宽>1080/1920");
        this.screenScale = innerWidth / 1920;
      } else {
        this.screenScale = 1;
      }
      document.body.style.setProperty("--scaleRate", this.screenScale);
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowHeight); // 组件销毁时移除resize事件监听器
  },
}
</script>

<style>
#app {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  font-size: 16px;
  line-height: 1;
  background-color: #081331;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue